import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { background_onboarding } from "../../constants/icons";

const KycVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const documentUrl = location.state?.documentUrl;
  const searchParams = new URLSearchParams(location.search);
  const goToSuccess = searchParams.get("gotosuccess") === "yes";
  const goToRejection = searchParams.get("gotorejection") === "yes";
  const supportRequestedRef = useRef(false);

  useEffect(() => {
    if (!goToRejection) return;
    // Announce the rejection once, and only once: closing the modal re-renders
    // this page, and announcing again would re-open it and trap the user here.
    // The announcement waits for the next tick because App picks it up from an
    // effect of its own, and effects run child-first — sent straight from here
    // it would arrive before anyone is listening. Deliberately not cleared on
    // unmount: cancelling it is what silently swallowed the announcement.
    setTimeout(() => {
      if (supportRequestedRef.current) return;
      supportRequestedRef.current = true;
      const message =
        "Your KYC verification was not approved. Please contact our support team so we can assist you in resolving this.";
      window.dispatchEvent(
        new CustomEvent("openSupportModal", { detail: { message } })
      );
    });
  }, [goToRejection]);

  if (goToSuccess) {
    return (
      <div
        className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center p-4"
        style={{
          backgroundImage: `url(${background_onboarding})`,
        }}
      >
        <div className="bg-white p-8 w-full max-w-[544px] flex flex-col rounded-xl gap-4 items-center text-center">
          <div className="text-[#1A212F] text-2xl font-bold">KYC Verification Completed</div>
          <div className="text-[#1A212F] text-base">Your KYC has been successfully completed.</div>
          <button
            type="button"
            aria-label="Go to Dashboard"
            onClick={() => navigate("/")}
            className="mt-2 w-full h-[44px] rounded-lg bg-[#2283FF] text-white text-[14px] font-medium"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  if (!documentUrl) {
    // The verification link only ever arrives through navigation state
    // (useHomeDashboard.js:194), so a reload or a step back leaves nothing to
    // show. Without this the page rendered an empty white card around an
    // iframe with no source, and the applicant had no way out.
    return (
      <div
        className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center p-4"
        style={{
          backgroundImage: `url(${background_onboarding})`,
        }}
      >
        <div className="bg-white p-8 w-full max-w-[544px] flex flex-col rounded-xl gap-4 items-center text-center">
          <div className="text-[#1A212F] text-2xl font-bold">Verification Link Expired</div>
          <div className="text-[#1A212F] text-base">
            This verification session is no longer available. Please start the
            verification again from your dashboard.
          </div>
          <button
            type="button"
            aria-label="Go to Dashboard"
            onClick={() => navigate("/")}
            className="mt-2 w-full h-[44px] rounded-lg bg-[#2283FF] text-white text-[14px] font-medium"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center p-4"
      style={{
        backgroundImage: `url(${background_onboarding})`,
      }}
    >
      <div className="bg-white p-6 w-full max-w-[544px] flex flex-col rounded-xl gap-6">
        <iframe
          src={documentUrl}
          title="KYC verification"
          className="flex w-full h-[700px] rounded-lg"
        ></iframe>
      </div>
    </div>
  );
};

export default KycVerification;